(() => {
  const dialog = document.getElementById('sb-guarantee-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let opener;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sb-guarantee]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); opener = link;
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-sb-guarantee-close]').focus();
  });
  dialog.querySelector('[data-sb-guarantee-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus(); });
})();
